import { useMutation } from '@tanstack/react-query';
import { putAdminFeedbackCycle } from './requests';

const useUpdateAdminFeedbackCycle = () =>
  useMutation({
    mutationFn: putAdminFeedbackCycle,
  });

export default useUpdateAdminFeedbackCycle;
